module.exports = __webpack_public_path__ + "img/edit-2.e48dd6c5.svg";